/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-filename-extension */
import {
  ZlAutoIcon,
  ZlEmpresarialIcon,
  ZlHabitacionalIcon,
  ZlResidencialIcon,
  ZlSaudeIcon,
} from "../components/common/ZIcons";
import { ReactComponent as Habitacional } from "../assets/images/icons/chat-habitacional-icon.svg";
import { ReactComponent as Residencial } from "../assets/images/icons/chat-residencial-icon.svg";
import { ReactComponent as Empresarial } from "../assets/images/icons/chat-empresarial-icon.svg";
import {
  chatIdEmpresarialServicos,
  chatIdHabitacionalServicos,
  chatIdResidencialServicos,
} from "./chat";
import * as LINKS from "./links";

const cuidados = {
  sonhos: "cuidar-dos-sonhos",
  bens: "cuidar-dos-bens",
  familia: "cuidar-da-familia",
  futuro: "cuidar-do-futuro",
};

export const chatButtons = [
  {
    label: "Seguro Habitacional",
    chatId: chatIdHabitacionalServicos,
    icon: <Habitacional/>,
    cuidado: cuidados.bens,
  },
  {
    label: "Seguro Empresarial",
    chatId: chatIdEmpresarialServicos,
    icon: <Empresarial/>,
    cuidado: cuidados.bens,
  },
  {
    label: "Seguro Residencial",
    chatId: chatIdResidencialServicos,
    icon: <Residencial/>,
    cuidado: cuidados.bens,
  },
];

export default [
  {
    cuidado: cuidados.bens,
    label: "Cuidar dos Bens",
    items: [
      {
        label: "Seguro Habitacional",
        href: LINKS.habitacional.home,
        icon: ZlHabitacionalIcon,
      },
      {
        label: "Seguro Residencial",
        href: LINKS.residencial.home,
        icon: ZlResidencialIcon,
      },
      {
        label: "Seguro Empresarial",
        href: LINKS.SeguroEmpresarial,
        icon: ZlEmpresarialIcon,
      },
      {
        label: (
          <>
            Seguro Auto <small>(até 21/05/2021)</small>
          </>
        ),
        href: LINKS.seguroAutoAntigo,
        icon: ZlAutoIcon,
      },
      {
        label: (
          <>
            Seguro Auto <small>(a partir de 22/05/2021)</small>
          </>
        ),
        href: LINKS.seguroAutoNovo,
        icon: ZlAutoIcon,
      },
    ],
  },
  {
    cuidado: "cuidar-da-saude",
    label: "Cuidar da Saúde",
    items: [
      {
        label: "Seguro Saúde",
        href: LINKS.seguroSaude,
        icon: ZlSaudeIcon,
      },
    ],
  },
];
